<template>
  <v-container>
    <ViewHeader :title="viewTitle" />
    <v-card class="card-wrapper">
      <template v-if="canManageGmbAccount">
        <v-row>
          <v-col cols="12" md="6">
            <ui-button color="primary" @click="importFromGMB">
              {{ $t("message.facilitiesAddNew.importFromGoogleMyBusiness") }}
            </ui-button>
            <paragraph class="mt-4 pr-5">
              {{
                $t(
                  "message.facilitiesAddNew.importFromGoogleMyBusinessDescription"
                )
              }}
            </paragraph>
          </v-col>
          <v-col cols="12" md="6">
            <ul>
              <li>
                <v-icon class="d-flex justify-center" color="green-1">
                  icon-check
                </v-icon>
                {{
                  $t("message.facilitiesAddNew.analysisPositionAtGoogleMaps")
                }}
              </li>
              <li>
                <v-icon class="d-flex justify-center" color="green-1">
                  icon-check
                </v-icon>
                {{
                  $t(
                    "message.facilitiesAddNew.comparingWithCommercialFacilities"
                  )
                }}
              </li>
              <li>
                <v-icon class="d-flex justify-center" color="green-1">
                  icon-check
                </v-icon>
                {{ $t("message.facilitiesAddNew.updateDataOnGoogleMaps") }}
              </li>
              <li>
                <v-icon class="d-flex justify-center" color="green-1">
                  icon-check
                </v-icon>
                {{ $t("message.facilitiesAddNew.accessToStatistics") }}
              </li>
            </ul>
          </v-col>
        </v-row>
        <v-divider class="mt-4 mb-6"></v-divider>
      </template>
      <template v-if="canManageExternalGmbAddresses">
        <v-row>
          <v-col cols="12" md="6">
            <ui-button color="primary" @click="searchOnGoogleMaps">
              {{ $t("message.facilitiesAddNew.searchOnGoogleMaps") }}
            </ui-button>
            <paragraph class="mt-4 pr-5">
              {{ $t("message.facilitiesAddNew.searchOnGoogleMapsDescription") }}
            </paragraph>
          </v-col>
          <v-col cols="12" md="6">
            <ul>
              <li>
                <v-icon class="d-flex justify-center" color="green-1">
                  icon-check
                </v-icon>
                {{
                  $t("message.facilitiesAddNew.analysisPositionAtGoogleMaps")
                }}
              </li>
              <li>
                <v-icon class="d-flex justify-center" color="green-1">
                  icon-check
                </v-icon>
                {{
                  $t(
                    "message.facilitiesAddNew.comparingWithCommercialFacilities"
                  )
                }}
              </li>
              <li>
                <v-icon class="d-flex justify-center" color="red-1">
                  icon-close
                </v-icon>
                {{ $t("message.facilitiesAddNew.updateDataOnGoogleMaps") }}
              </li>
              <li>
                <v-icon class="d-flex justify-center" color="red-1">
                  icon-close
                </v-icon>
                {{ $t("message.facilitiesAddNew.accessToStatistics") }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </template>

      <template v-if="!canManageGmbAccount && !canManageExternalGmbAddresses">
        <div class="no-access">
          <p>{{ $t("message.facilitiesAddNew.noAccess") }}</p>
          <ui-button color="primary" outlined @click="goBack">
            {{ $t("message.common.backToList") }}
          </ui-button>
        </div>
      </template>

      <ui-button
        v-if="canManageGmbAccount || canManageExternalGmbAddresses"
        color="primary"
        outlined
        @click="goBack"
      >
        {{ $t("message.common.backToList") }}
      </ui-button>
    </v-card>
    <NewFacilityDialog
      :isOpen="newFacilityDialogState"
      @closeDialog="newFacilityDialogState = !newFacilityDialogState"
    />
  </v-container>
</template>
<script>
import Paragraph from "@/components/ui/Paragraph";
import ViewHeader from "@/components/ui/ViewHeader.vue";
import NewFacilityDialog from "@/components/ListingsConfiguration/Dialog/NewFacility.vue";

import { permissionsInfo } from "@/helpers/mixins/permissions-info";
import { gtmEvent__buttonClick } from "@/helpers/gtm-events";

export default {
  name: "FacilityAddNew",
  components: { Paragraph, ViewHeader, NewFacilityDialog },
  mixins: [permissionsInfo],
  data() {
    return {
      viewTitle: this.$t("message.facilitiesAddNew.addExistingFacilities"),
      newFacilityDialogState: false
    };
  },
  methods: {
    importFromGMB() {
      gtmEvent__buttonClick({ label: "import_from_gmb" });

      this.$router.push({ name: "profile-gmb-accounts" });
    },
    searchOnGoogleMaps() {
      gtmEvent__buttonClick({ label: "search_on_google_maps" });

      this.newFacilityDialogState = !this.newFacilityDialogState;
    },
    goBack() {
      gtmEvent__buttonClick({ label: "go_back" });

      this.$router.push({ name: "business-addresses" });
    }
  }
};
</script>
<style lang="scss" scoped>
.card-wrapper {
  padding: $spacing * 5 $spacing * 7.5;
}
ul {
  padding-left: 0;
}

ul li {
  list-style: none;
  position: relative;
  padding-left: 30px;
  margin-bottom: $spacing;
}

ul li i {
  left: 0;
  position: absolute !important;
}

.no-access {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}
</style>
